import React, { useRef }    from 'react';
import PropTypes            from 'prop-types';
import ReCAPTCHA            from 'react-google-recaptcha';

import Header               from '../../components/Header';
import Footer               from '../../components/Footer';
import Input                from '../../components/Input';
import Button               from '../../components/Button';
import RightBG              from '../../../assets/images/contacts.png';

import { getErrorsText }    from '../../../utils/errors.js';

import useContactPage       from './useContactPage';

import styles               from './ContactPage.styl';

function ContactPage() {
    // const { className, children, ...rest } = props;
    const captchaRef = useRef();

    const {
        handleChange,
        handleSubmit,
        isSaveLoading,
        values,
        errors
    } = useContactPage(captchaRef);

    return  (
        <div
            className = {styles.ContactPage}
        >
            <div
                className={styles.blockWrapper}
                style     = {{
                    backgroundImage    : `url(${RightBG})`,
                    backgroundPosition : 'right',
                    backgroundSize     : 'contain',
                    backgroundRepeat   : 'no-repeat'
                }}
            >
                <Header theme='light' />
                <div className={styles.content}>
                    <div className={styles.leftBlock}>
                        <h2 className={styles.title}>
                            Contact Us
                        </h2>
                        <div className={styles.formBlock}>
                            <Input
                                placeholder = 'Email'
                                className   = {styles.input}
                                onChange    = {handleChange('email')}
                                value       = {values.email}
                                error       = {getErrorsText(errors.email)}
                            /> 
                            <Input
                                placeholder = 'Company Name'
                                className   = {styles.input}
                                onChange    = {handleChange('companyName')}
                                value       = {values.companyName}
                                error       = {getErrorsText(errors.companyName)}
                            />
                            <Input
                                placeholder = 'First Name'
                                className   = {styles.input}
                                onChange    = {handleChange('firstName')}
                                value       = {values.firstName}
                                error       = {getErrorsText(errors.firstName)}
                            />
                            <Input
                                placeholder = 'Last Name'
                                className   = {styles.input}
                                onChange    = {handleChange('lastName')}
                                value       = {values.lastName}
                                error       = {getErrorsText(errors.lastName)}
                            />
                            <Input
                                type        = 'textarea'
                                placeholder = 'Message'
                                className   = {styles.textarea}
                                onChange    = {handleChange('message')}
                                value       = {values.message}
                                error       = {getErrorsText(errors.message)}
                            />
                        </div>
                        <div className={styles.checkboxBlock}>
                            <div className={styles.agreeText}>
                                I give consent to the processing of my personal data given in the contact form above 
                                as well as receiving commercial and marketing communications under the terms and conditions of Roimax Privacy Policy.
                            </div>
                        </div>
                        <Button
                            className = {styles.button}
                            color     = 'gradient'
                            onClick   = {handleSubmit}
                            loading   = {isSaveLoading}
                        >
                            Submit an inquiry
                        </Button>
                    </div>
                </div>
            </div>
            <Footer theme='light' />
            <ReCAPTCHA
                ref={captchaRef}
                size='invisible'
                sitekey='6LcKgNMiAAAAAMNYtke87BhLUPtUMB91y3jqg3Q7'
            />
        </div>
    );
}

ContactPage.propTypes = {
    className : PropTypes.string
};

ContactPage.defaultProps = {
    className : ''
};

export default ContactPage;
